import { useMemo } from 'react';
import { Box } from '@mui/material';

import { ScheduleDayColumn, ScheduleGridHeader, ScheduleTimeColumn } from './components';
import { WEEKLY_SCHEDULE_DAYS } from './constants';
import { WEEKLY_SCHEDULE_GRID_SX, WEEKLY_SCHEDULE_ROOT_SX } from './styles';
import { groupScheduleItemsByDay } from './utils/general';

import type { FWeeklyScheduleProps } from './types';

export default function FWeeklySchedule({ values, onDelete, sx }: FWeeklyScheduleProps) {
  const itemsByDay = useMemo(() => groupScheduleItemsByDay(values), [values]);

  return (
    <Box sx={[WEEKLY_SCHEDULE_ROOT_SX, ...(Array.isArray(sx) ? sx : [sx])]}>
      <ScheduleGridHeader />
      <Box sx={WEEKLY_SCHEDULE_GRID_SX}>
        <ScheduleTimeColumn />
        {WEEKLY_SCHEDULE_DAYS.map((day) => (
          <ScheduleDayColumn
            key={day.key}
            items={itemsByDay.get(day.key) ?? []}
            onDelete={onDelete}
          />
        ))}
      </Box>
    </Box>
  );
}
